import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SubmitTicketParams } from "./types";

export type SupportState = {
  isTicketSubmitting: boolean;
};

const initialState: SupportState = {
  isTicketSubmitting: false
};

export const supportSlice = createSlice({
  name: "support",
  initialState,
  reducers: {
    // Submit Ticket
    submitTicketRequest(state, action: PayloadAction<SubmitTicketParams>) {
      state.isTicketSubmitting = true;
    },
    submitTicketSuccess(state) {
      state.isTicketSubmitting = false;
    },
    submitTicketFailure(
      state,
      action: PayloadAction<{ params: SubmitTicketParams; error: string }>
    ) {
      state.isTicketSubmitting = false;
    }
  }
});

export const { actions: supportActions } = supportSlice;

export const reducer = supportSlice.reducer;

export default supportSlice.reducer;
